import { AdvancedFiltersContainer } from '../../containers/filters/AdvancedFiltersContainer';
import { EFilterType, IOpenableFilter } from '../../types/filters';

export const advancedFilters: IOpenableFilter = {
  component: AdvancedFiltersContainer,
  type: EFilterType.Openable,
};
